import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { images, navLinks, links, TID } from "@/data";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const solid = !isHome || scrolled;

  return (
    <header className={`nav ${solid ? "nav--scrolled" : ""}`}>
      <div className="nav__inner">
        <Link to="/" className="nav__logo" data-testid={TID.navLogo} aria-label="HI Tours Group home">
          <img src={images.logoWhite} alt="HI Tours Group" />
        </Link>

        <nav className="nav__links" aria-label="Primary">
          {navLinks.map((l) => (
            <Link key={l.label} to={l.href}>{l.label}</Link>
          ))}
        </nav>

        <div className="nav__right">
          <a href={links.careers} target="_blank" rel="noopener noreferrer" className="btn btn--pill nav__careers" data-testid={TID.navCareers}>
            <span className="btn__dot" />Careers
          </a>
          <button className="nav__burger" aria-label="Open menu" data-testid={TID.navMenuOpen} onClick={() => setOpen(true)}>
            <span /><span /><span />
          </button>
        </div>
      </div>

      <div className={`nav__drawer ${open ? "nav__drawer--open" : ""}`}>
        <div className="nav__drawer-head">
          <img src={images.logoWhite} alt="HI Tours Group" className="nav__drawer-logo" />
          <button className="nav__close" aria-label="Close menu" data-testid={TID.navMenuClose} onClick={() => setOpen(false)}>
            <span /><span />
          </button>
        </div>
        <nav className="nav__drawer-links" aria-label="Mobile">
          {navLinks.map((l) => (
            <Link key={l.label} to={l.href}>{l.label}</Link>
          ))}
          <a href={links.careers} target="_blank" rel="noopener noreferrer" className="btn btn--pill nav__drawer-careers">
            <span className="btn__dot" />Careers
          </a>
        </nav>
      </div>
      {open && <div className="nav__overlay" onClick={() => setOpen(false)} />}
    </header>
  );
};

export default Navbar;
